module.exports = __webpack_public_path__ + "img/FairTradeFederationLogoBlack.d9c1464d.svg";